



































































































import { toRefs, reactive, defineComponent } from "@vue/composition-api";
import { useMainStore } from "@/store/storage";
import { db } from "./firebase/firebase";
import { Area, Client, Project, Zone, Locations } from "@/interfaces/interfaces";

export default defineComponent({
  name: "App",

  setup() {
    const main = useMainStore();
    const state = reactive({
      mainNav: [
        { title: "Home", route: "/", icon: "mdi-home" },
        {
          title: "Clients",
          route: "/clients",
          icon: "mdi-account"
        },
        {
          title: "Projects",
          route: "/projects",
          icon: "mdi-cog"
        },
        { title: "Reports", route: "/reports", icon: "mdi-file-chart" },
        { title: "Batch Upload", route: "/reportform", icon: "mdi-table" }
      ],
      navigation: [
        {
          title: "Inspection Areas",
          route: "/inspection_areas/",
          icon: "mdi-map-marker"
        },
        {
          title: "Inspection Zones",
          route: "/inspection_zones/",
          icon: "mdi-map"
        },
        {
          title: "Locations",
          route: "/locations",
          icon: "mdi-crosshairs-gps"
        }

        // {
        //   title: "Failed",
        //   route: "/survey/failed",
        //   icon: "mdi-alert-box-outline"
        // },
        // {
        //   title: "Passed",
        //   route: "/survey/passed",
        //   icon: "mdi-marker-check"
        // },
        // {
        //   title: "Not Set",
        //   route: "/survey/none",
        //   icon: "mdi-flask-empty-off-outline"
        // },
        //
      ],
      drawer: true,
      group: null
    });

    //get all inspection areas and store in main.state
    db.collection("InspectionAreas")
      .orderBy("area", "asc")
      .onSnapshot((snapshot) => {
        const areaList: Area[] = [];
        snapshot.forEach((item) => {
          const obj = { ...item.data(), id: item.id } as Area;
          areaList.push(obj);
        });
        main.state.inspectionAreas = areaList;
      });

    db.collection("InspectionZones")
      .orderBy("zone", "asc")
      .onSnapshot((snapshot) => {
        const list: Zone[] = [];
        snapshot.forEach((item) => {
          const obj = { ...item.data(), id: item.id } as Zone;
          list.push(obj);
        });
        main.state.inspectionZones = list;
      });
    db.collection("locations")
      .orderBy("order", "asc")
      .onSnapshot((snapshot) => {
        const list: Locations[] = [];
        snapshot.forEach((item) => {
          const obj = { ...item.data(), id: item.id } as Locations;
          list.push(obj);
        });
        main.state.locations = list;
      });

    //Get all clients from database and store in main.state
    db.collection("clients")
      .orderBy("companyName", "asc")
      .onSnapshot((snapshot) => {
        const clients: Client[] = [];
        snapshot.forEach((item) => {
          const obj = { ...item.data(), id: item.id } as Client;
          clients.push(obj);
        });
        main.state.clients = clients;
      });

    //Get all projects from database and store in main.state
    db.collection("projects").onSnapshot((snapshot) => {
      const projects: Project[] = [];
      snapshot.forEach((item) => {
        const obj = { ...item.data(), id: item.id } as Project;
        projects.push(obj);
      });
      main.state.projects = projects;
      console.log("setup -> main.state.projects", main.state.projects);
    });

    // const fbCollections = {
    //   area: db.collection("InspectionAreas"),
    //   zone: db.collection("InspectionZones"),
    //   locations: db.collection("locations"),
    //   surveys: db
    //     .collection("projects")
    //     .doc(main.state.projectName)
    //     .collection("surveys")
    // };
    //  type AreaObj = {[_: string]: Area};

    // db.collection("InspectionAreas")
    //   .orderBy("area", "asc")
    //   .onSnapshot((snapshot) => {
    //     const areaList: Area[] = [];
    //     snapshot.forEach((item) => {
    //       const obj = { id: item.id, ...item.data() } as Area;
    //       areaList.push(obj);
    //     });
    //     main.state.inspectionAreas = areaList;
    //   });

    // db.collection("projects")
    //   .doc(main.state.projectName)
    //   .collection("surveys")
    //   .orderBy("reference")
    //   .onSnapshot((snapshot) => {
    //     const records = [] as Survey[];
    //     snapshot.forEach((item) => {
    //       records.push({ id: item.id, ...item.data() } as Survey);
    //     });
    //     // main.state.projectSurvey = records;
    //     main.state.surveyProgress = false;
    //   });

    // main.updateAreas(
    //   fbCollections.area,
    //   fbCollections.zone,
    //   fbCollections.locations,
    //   fbCollections.surveys
    // );
    return {
      ...toRefs(state)
    };
  }
});
